export const wellnessThemes = [
  {
    id: "ayurveda",
    title: "Ayurveda",
    description: "Ancient healing wisdom rooted in balance, herbs, and holistic well-being from the heart of Kerala.",
    locations: ["Kumarakom", "Thiruvananthapuram & Kovalam", "Kottakkal", "Palakkad", "Thrissur", "Ashtamudi & Aluva"],
  },
  {
    id: "mindfulness",
    title: "Mindfulness Retreats",
    description: "Immerse in stillness. Discover profound peace through meditation in India's most sacred spaces.",
    locations: ["Rishikesh", "Dharamshala", "Auroville", "Igatpuri", "Bodh Gaya", "Tawang", "Spiti Valley"],
  },
  {
    id: "snow-healing",
    title: "Snow Healing",
    description: "Crisp mountain air, pristine snow, and the silent majesty of the Himalayas restore your spirit.",
    locations: ["Himachal Pradesh", "Kashmir", "Uttarakhand", "Sikkim", "Arunachal Pradesh", "Ladakh"],
  },
  {
    id: "forest-healing",
    title: "Forest Healing",
    description: "Breathe deep among ancient canopies. Let the forest's emerald embrace rejuvenate your soul.",
    locations: ["Meghalaya", "Chikmagalur", "Coorg", "Munnar", "Darjeeling"],
  },
  {
    id: "coastal-healing",
    title: "Coastal Healing",
    description: "Sun-kissed shores and rhythmic waves wash away stress, leaving only calm and renewal.",
    locations: ["Gokarna", "Andaman", "Goa", "Lakshadweep"],
  },
  {
    id: "spiritual-healing",
    title: "Spiritual Healing",
    description: "Walk the ancient paths of devotion. Find transcendence in India's most revered spiritual sanctuaries.",
    locations: ["Varanasi", "Shirdi", "Kedarnath", "Haridwar"],
  },
];
